import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import { FormsModule } from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {AgeRangeComponent} from "./age-range.component";
import {AgeRangeRoutingModule} from "./age-range-routing.module";
import {SharedModule} from "../../shared/shared.module";

@NgModule({
    imports: [CommonModule, FormsModule, AgeRangeRoutingModule, TranslateModule, SharedModule],
    declarations: [
        AgeRangeComponent,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AgeRangeModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/ageRange/age-range.module.ts